import {useTranslation} from "react-i18next";
import { Link } from "react-router";
import SlideUp from "components/animation/SlideUp";
import bg from 'assets/images/home/main04.png';

export default function Partners(){
  const {t} = useTranslation();
  return (
    <div className={`py-20 lg:py-32 flex justify-center bg`} style={{backgroundImage:`url(${bg})`}}>
      <div className="px-mobile lg:px-0 w-full lg:w-[1200px]">
      <SlideUp>
      <p className="mb-10 text-3xl tracking-wide lg:text-5xl text-dark-navy font-extralight">{t('home.partners.main-title')}</p>
      </SlideUp>
      <SlideUp delay={400}>
      <p className="mb-12 text-sm lg:text-base" dangerouslySetInnerHTML={{__html:t('home.partners.main-comment')}}></p>
      </SlideUp>
      <Link to="/partners" className="px-10 py-4 text-sm text-white lg:text-base bg-dark-navy">{t('home.partners.view-more')}</Link>
      </div>
    </div>
  );
}